import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { MessageService } from '../../shared/services/message.service';
import { LeftSidebarComponent } from '../../shared/left-sidebar/left-sidebar.component';

@Component({
  selector: 'app-daily-stats',
  standalone: true,
  imports: [LeftSidebarComponent, DecimalPipe],
  templateUrl: 'daily-stats.component.html',
})
export class DailyStatsComponent implements OnInit {
  private messageService = inject(MessageService);
  stats = signal<any[]>([]);

  sortedStats = computed(() =>
    [...this.stats()].sort(
      (a, b) =>
        b.record_year - a.record_year || b.record_month - a.record_month || b.record_day - a.record_day,
    ),
  );

  totalRecords = computed(() => this.stats().reduce((sum, stat) => sum + stat.total_records, 0));

  maxRecords = computed(() => this.stats().reduce((max, stat) => Math.max(max, stat.total_records), 0));

  ngOnInit() {
    this.loadDailyStats();
  }

  loadDailyStats() {
    this.messageService.getDailyStats().subscribe({
      next: (data) => this.stats.set(data.stats),
      error: (err) => console.error(err),
    });
  }
}
